import AbstractDeviceSetup from '../all/AbstractDeviceSetup';
import storage from '../../components/DeviceStorage/DeviceStorage';

class STBCoship9108DeviceSetup extends AbstractDeviceSetup {
    constructor() {
        super();
    }

    setup() {
        STBCoship9108DeviceSetup.getUserInfo();
    }

    static getUserInfo() {
        let response = null;
        try {
            response = window.AndroidPlayerInterface.getUserInformation();
        } catch (e) {
            console.error('[STBCoship9108DeviceSetup.getUserInfo]', e);
        }
        if (response) {
            const result = JSON.parse(response);
            if (result.userHash && result.sessionStringValue && result.region) {
                const user_hash = result.userHash;
                const HKS = result.sessionStringValue;
                const { region } = result;
                storage.setItem('HKS', HKS);
                storage.setItem('user_hash', user_hash);
                storage.setItem('region', region);
            }
        }
    }
}

export default STBCoship9108DeviceSetup;



// WEBPACK FOOTER //
// ./src/devices/stbcoship9108/DeviceSetup.js